import enumHelper from "./enumHelper";

const REPORT_PATH_PREFIX = "/rapor-sayfasi/";

function collectReportPermissions(nodes, acc) {
  if (!Array.isArray(nodes)) return;
  for (const node of nodes) {
    if (node && typeof node.route === "string" && node.route.startsWith(REPORT_PATH_PREFIX) && typeof node.pagePermissionTag === "string") {
      acc[node.route] = node.pagePermissionTag;
    }
    if (node && Array.isArray(node.children) && node.children.length > 0) {
      collectReportPermissions(node.children, acc);
    }
  }
}

function buildReportPermissionMap() {
  const map = {};
  try {
    const source = (enumHelper && (enumHelper.allMenuTree || enumHelper.allMenuList)) || [];
    collectReportPermissions(source, map);
  } catch (e) {
    // enumHelper okunamazsa guard riskli davranmaktansa mevcut akışı koruyacak şekilde boş map döner.
  }
  return map;
}

const reportPermissionMap = buildReportPermissionMap();

export function getReportPermissionTag(path) {
  if (typeof path !== "string" || !path.startsWith(REPORT_PATH_PREFIX)) return null;
  return reportPermissionMap[path] || null;
}

export function isReportMapReady() {
  return Object.keys(reportPermissionMap).length > 0;
}

export { REPORT_PATH_PREFIX };
export default reportPermissionMap;
